import {FeedbackReducerActionType, useFeedbackDispatch} from "../../utils/FeedbackContext";
import {useEffect, useRef, useState} from "react";
import {getDependants} from "../../api/RestCallHelper";
import {useHistory, useLocation} from "react-router-dom";
import FetchState from "../../api/FetchState";

export function useFetchDependants() {

    console.log("In useFetchDependants hook");

    let history = useHistory();
    let location = useLocation();

    const [fetchState, setFetchState] = useState(FetchState.LOADING);
    const dispatch = useFeedbackDispatch();

    const [data, setData] = useState([]);
    const [isSending, setIsSending] = useState(false);
    const isMounted = useRef(true);

    const close = (event, reason) => {
        console.log("In useFetchDependants close callback");
        if (reason === 'clickaway') return;

        dispatch({type: FeedbackReducerActionType.CLOSE_FEEDBACK});
    };

    useEffect(() => {

        console.log("In useFetchDependants effect");


        // don't send again while we are sending
        if (isSending) return;

        // update state
        setIsSending(true);

        getDependants(setData, true, dispatch, setFetchState, close, history, location);

        // once the request is sent, update state again
        if (isMounted.current)
            // only update if we are still mounted
            setIsSending(false);

    }, []);

    return [data, fetchState];

}
